// @ts-nocheck
/* eslint-disable */

import React, { useState, useEffect } from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions,
  FormControl, InputLabel, Select, MenuItem, TextField, CircularProgress,
} from '@material-ui/core';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { useTypedSelector } from 'helpers';
import { hasWriteAccessToMasterConfigSubSystem } from 'selectors';

// v7: change a USER's passenger group via a modal (calls passengers_groups/move-user-group).
const BASE_URL = process.env.REACT_APP_ABT_ALL_APIS_BASE_URL;
const PG = `${BASE_URL}/api/v1/web_portal/fare_media_policy_capping/passengers_groups`;

const UserGroupMove = ({ userId, currentGroupId }) => {
  const intl = useIntl();
  const lang = localStorage.getItem('EASY_MOBILITY_LANGUAGE') || 'en-us';
  const hasWriteAccess = useTypedSelector((s) => hasWriteAccessToMasterConfigSubSystem(s, 'Users'));

  let userAuthData = '';
  const authData = localStorage.getItem('authData');
  if (authData) userAuthData = JSON.parse(authData).userToken;
  const headers = { 'access-token': userAuthData?.['access-token'], uid: userAuthData?.uid, client: userAuthData?.client };

  const [open, setOpen] = useState(false);
  const [groups, setGroups] = useState([]);
  const [selected, setSelected] = useState(currentGroupId || '');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open && groups.length === 0) {
      axios.get(`${PG}?pageSize=1000`, { headers })
        .then((res) => setGroups(res?.data?.data?.passengersGroups || []))
        .catch(() => setGroups([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const openDialog = () => { setSelected(currentGroupId || ''); setReason(''); setOpen(true); };

  const submit = async () => {
    if (!selected) return;
    // Same group selected → nothing to change; just close (backend would no-op anyway).
    if (selected === currentGroupId) { setOpen(false); return; }
    setSaving(true);
    try {
      await axios.post(`${PG}/move-user-group?lang=${lang}`, { user_id: userId, new_group_id: selected, reason: reason?.trim() || undefined }, { headers });
      toast.success(intl.formatMessage({ id: 'UserGroupUpdated' }));
      setOpen(false);
      setTimeout(() => window.location.reload(), 600);
    } catch (e) {
      toast.error(e?.response?.data?.message || 'Error');
    } finally {
      setSaving(false);
    }
  };

  if (!hasWriteAccess) return null;

  return (
    <>
      <button
        className="styleAddBtn"
        style={{ position: 'inherit', marginTop: '-10px', marginRight: '5px', paddingBottom: '7px', paddingTop: '8px' }}
        onClick={openDialog}
      >
        <EditIcon style={{ fontSize: '24px', paddingRight: '3px', paddingLeft: '3px' }} />
        {intl.formatMessage({ id: 'ChangePassengerGroup' })}
      </button>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{intl.formatMessage({ id: 'ChangePassengerGroup' })}</DialogTitle>
        <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: '12px', paddingTop: '16px' }}>
          <FormControl variant="outlined" size="small" fullWidth required>
            <InputLabel>{intl.formatMessage({ id: 'GroupName' })}</InputLabel>
            <Select value={selected} onChange={(e) => setSelected(e.target.value)} label={intl.formatMessage({ id: 'GroupName' })}>
              {groups.map((g) => (
                <MenuItem key={g.passengers_groups_id} value={g.passengers_groups_id}>
                  {lang === 'en-us' ? g.en_name || g.name : g.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField label={intl.formatMessage({ id: 'group_change_reason' })} value={reason} onChange={(e) => setReason(e.target.value)} variant="outlined" size="small" fullWidth multiline minRows={2} InputLabelProps={{ shrink: true }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={saving}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button onClick={submit} disabled={saving || !selected} variant="contained" style={{ backgroundColor: '#363740', color: '#fff' }}>
            {saving ? <CircularProgress size={18} style={{ color: '#fff' }} /> : intl.formatMessage({ id: 'save' })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserGroupMove;
